import {
  IconHeart,
  IconFlame,
  IconShield,
  IconDna,
  IconDroplet,
  IconApple,
  IconClock,
} from '@tabler/icons-react';
import type { LongevityDomain } from '../../types/portal';

const iconMap: Record<string, React.ComponentType<{ size?: number; className?: string; stroke?: number }>> = {
  IconHeart,
  IconFlame,
  IconShield,
  IconDna,
  IconDroplet,
  IconApple,
};

interface DomainCardProps {
  domain: LongevityDomain;
}

export function DomainCard({ domain }: DomainCardProps) {
  const Icon = iconMap[domain.icon];

  return (
    <div className="card p-5">
      <div className="flex items-start justify-between mb-3">
        <div className="w-10 h-10 rounded-lg bg-cyan-900/30 border border-cyan-500/20 flex items-center justify-center">
          {Icon && <Icon size={22} className="text-cyan-400" stroke={1.5} />}
        </div>
        <div className="flex items-center gap-1 text-xs text-gray-500">
          <IconClock size={12} />
          <span>Coming soon</span>
        </div>
      </div>

      <h3 className="font-semibold text-gray-100 text-sm mb-1">{domain.title}</h3>
      <p className="text-xs text-gray-500 leading-relaxed">{domain.description}</p>
    </div>
  );
}
